import { FieldPanelHeader } from 'styles/v2/Styles.styled';
import DataQualityAssessmentAndReferenceYearsGridPdf from '../../grids/data-quality-assessment-and-ref-years/DataQualityAssessmentAndReferenceYearsGridPdf';
import { DataQualityAssessmentReadModel } from 'types/types';
import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';
import { NOT_ASSIGNED } from 'constants/constants';
import styled from 'styled-components';
import usePcrV2 from '../../hooks/usePcrV2';
import { isArraySingleEmptyValue } from 'util/utils';

const VersionHistoryDataQualityAssessmentGrid: React.FC<{
  dataQualityAssessmentAndReferenceYears: DataQualityAssessmentReadModel;
}> = ({ dataQualityAssessmentAndReferenceYears }) => {
  const isPcrV2 = usePcrV2();

  // #11472. The users visually can't to figure out whether the empty row is added by default or they forgot to delete empty row, which was added by them before.
  // So it is needed to hide the table if the single entity with empty fields is existed.
  const isOnlySingleEmptyRow =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    isArraySingleEmptyValue(dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems);

  const anyRows =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems.length > 0 &&
    !isOnlySingleEmptyRow;

  const summaryExists =
    !!dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary &&
    (!!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ||
      !!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary.dataQualityAssessmentComment);

  if (!anyRows && !summaryExists) {
    return null;
  }

  const summaryRow: SummaryGridRow[] = [];
  if (dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary) {
    summaryRow.push({
      name: 'Description of data quality assessment and reference years',
      value:
        dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ?? NOT_ASSIGNED,
    });
  }

  const commentRow: SummaryGridRow[] = [];
  if (isPcrV2 && dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentComment) {
    commentRow.push({
      name: 'Comment on the data sources and other information in the table',
      value:
        dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentComment ?? NOT_ASSIGNED,
    });
  }

  return (
    <>
      <StyledFieldPanelHeader>
        {isPcrV2 ? 'Data quality assessment' : 'Data quality assessment and reference years'}
      </StyledFieldPanelHeader>
      {summaryRow.length > 0 && (
        <ContentWrapper>
          <VersionHistorySummaryGrid rows={summaryRow} />
        </ContentWrapper>
      )}

      {anyRows && (
        <DataQualityAssessmentAndReferenceYearsGridPdf
          dataQualityAssessmentItems={dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems}
        />
      )}

      {commentRow.length > 0 && (
        <ContentWrapper>
          <VersionHistorySummaryGrid rows={commentRow} />
        </ContentWrapper>
      )}
    </>
  );
};

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledFieldPanelHeader = styled(FieldPanelHeader)`
  gap: 20px;
`;

export default VersionHistoryDataQualityAssessmentGrid;
